import { styled } from '@acko-tech/building-blocks.ui.common';

export const SnackBarWrapper = styled.div`
    min-width: 250px;
    background-color: ${(props) => props.backgroundColor};
    color: #fff;
    text-align: center;
    padding: 12px;
    position: fixed;
    z-index: 100;
    bottom: 30px;
    border-radius: 8px;

    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
    animation: fadein 0.5s, fadeout 0.5s 2.5s;

    @-webkit-keyframes fadein {
        from {
            bottom: 0;
            opacity: 0;
        }
        to {
            bottom: 30px;
            opacity: 1;
        }
    }

    @keyframes fadein {
        from {
            bottom: 0;
            opacity: 0;
        }
        to {
            bottom: 30px;
            opacity: 1;
        }
    }

    @-webkit-keyframes fadeout {
        from {
            bottom: 30px;
            opacity: 1;
        }
        to {
            bottom: 0;
            opacity: 0;
        }
    }

    @keyframes fadeout {
        from {
            bottom: 30px;
            opacity: 1;
        }
        to {
            bottom: 0;
            opacity: 0;
        }
    }
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    padding: 2px;
`;

export const Icon = styled.div`
    width: 16px;
    @media screen and (min-width: 780px) {
        width: 18px;
    }
`;

export const MessageText = styled.div`
    display: flex;
    align-items: center;
    font-weight: normal;
    font-size: 10px;
    line-height: 20px;
    letter-spacing: 0.2px;
    color: #ffffff;
    margin-left: 10px;

    @media screen and (min-width: 780px) {
        font-size: 14px;
    }
`;
